;(function () {
  angular
    .module('contrast.notifications.users')
    .controller('UserNotificationsCtrl', UserNotificationsCtrl)

  function UserNotificationsCtrl(
    $scope,
    $filter,
    $q,
    permissions,
    UserFactory,
    FeaturesFactory,
    ErrorService
  ) {
    'ngInject'

    var showAlertAttacks = false

    //models
    angular.extend($scope, {
      model: {
        row: ''
      },
      alerts: []
    })

    //functions
    angular.extend($scope, {
      onOrderChange: function () {
        $scope.select(1)
        return ($scope.model.currentPage = 1)
      },
      order: function (rowName) {
        if ($scope.model.row === rowName) {
          return
        }
        $scope.model.row = rowName
        $scope.alerts = $filter('orderBy')($scope.alerts, rowName)
        return $scope.onOrderChange()
      }
    })

    function loadFeatures() {
      return FeaturesFactory.getFeaturesByKeys(['rasp']).then(function (
        response
      ) {
        for (var i = 0; i < response.data.length; i++) {
          var feature = response.data[i]
          if (feature.key === 'rasp') {
            if (feature.active) {
              showAlertAttacks = permissions.isRASPEnabled()
            } else {
              showAlertAttacks = false
            }
          }
        }
      })
    }

    function init() {
      var promises = []
      promises.push(loadFeatures())

      $q.all(promises).then(function () {
        loadAlerts()
      })
    }

    function loadAlerts() {
      if (showAlertAttacks) {
        loadOrganizationAlerts()
      } else {
        loadVulnAlerts()
      }
    }

    function loadVulnAlerts() {
      $scope.alertsPromise = UserFactory.getVulnAlerts().then(
        function (response) {
          $scope.alerts = response.data.alerts
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function loadOrganizationAlerts() {
      $scope.alertsPromise = UserFactory.getAlerts().then(
        function (response) {
          $scope.alerts = response.data.alerts
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    init()
  }
})()
